import axios from "axios";
import { getAuthHeader } from "../utils/get-token";

//GET call
function get(url, option = {}) {
	return axios.get(url, {
		...(option || {}),
		headers: {
			...getAuthHeader(),
			...(option?.headers || {}),
		},
	});
}

//POST call
function post(url, body, option = {}) {
	return axios.post(url, body, {
		...(option || {}),
		headers: {
			"Content-Type": "application/json",
			...getAuthHeader(),
			...(option?.headers || {}),
		},
	});
}

//PUT call
function put(url, body, option = {}) {
	return axios.put(url, body, {
		...(option || {}),
		headers: {
			"Content-Type": "application/json",
			...getAuthHeader(),
			...(option?.headers || {}),
		},
	});
}

//PATCH call
function patch(url, body, option = {}) {
	return axios.patch(url, body, {
		...(option || {}),
		headers: {
			"Content-Type": "application/json",
			...getAuthHeader(),
			...(option?.headers || {}),
		},
	});
}

export { get, patch, post, put };
